import _classCallCheck from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { NonInviteServerTransaction } from "../transactions";
import { UserAgentServer } from "./user-agent-server"; // eslint-disable-next-line @typescript-eslint/no-explicit-any

function instanceOfSessionDialog(object) {
  return object.userAgentCore !== undefined;
}
/**
 * REFER UAS.
 * @public
 */


export var ReferUserAgentServer = /*#__PURE__*/function (_UserAgentServer) {
  _inherits(ReferUserAgentServer, _UserAgentServer);

  /**
   * REFER UAS constructor.
   * @param dialogOrCore - Dialog for in dialog REFER, UserAgentCore for out of dialog REFER.
   * @param message - Incoming REFER request message.
   */
  function ReferUserAgentServer(dialogOrCore, message, delegate) {
    _classCallCheck(this, ReferUserAgentServer);

    var userAgentCore = instanceOfSessionDialog(dialogOrCore) ? dialogOrCore.userAgentCore : dialogOrCore;
    return _possibleConstructorReturn(this, _getPrototypeOf(ReferUserAgentServer).call(this, NonInviteServerTransaction, userAgentCore, message, delegate));
  }

  return ReferUserAgentServer;
}(UserAgentServer);